"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core/");
const react_redux_1 = require("react-redux");
const modalsSlice_1 = require("../../../../redux/slices/modalsSlice");
const expertsSlice_1 = require("../../../../redux/slices/expertsSlice");
require("./../singleExpert/components/editExpert.scss");
const ExpertSave = (props) => {
    const { open, data } = props;
    const save = async () => {
        var _a, _b;
        if (data.type === 'publish') {
            props.editExpert({ key: "status", val: 1 });
        }
        const snackBarProps = {
            root: '',
            key: 'snackbar',
        };
        try {
            const res = await props.submit();
            closeModal();
            if ((res === null || res === void 0 ? void 0 : res.code) === 400) {
                return props.triggerModal(Object.assign(Object.assign({}, snackBarProps), { val: {
                        type: 'error',
                        text: (_a = res.data) === null || _a === void 0 ? void 0 : _a.message
                    } }));
            }
            props.triggerModal(Object.assign(Object.assign({}, snackBarProps), { val: {
                    type: 'success',
                    text: `Expert successfully ${data.text}`
                } }));
        }
        catch (e) {
            const msg = ((_b = e === null || e === void 0 ? void 0 : e.data) === null || _b === void 0 ? void 0 : _b.message) || e.toString();
            props.triggerModal(Object.assign(Object.assign({}, snackBarProps), { val: {
                    type: 'error',
                    text: msg
                } }));
        }
    };
    const closeModal = () => props.triggerModal({ key: 'experts.save.open', val: false });
    return (react_1.default.createElement(core_1.Dialog, { open: open, className: "save-publish p-0", maxWidth: 'sm', fullWidth: true, onClose: () => closeModal() }, data && react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(core_1.DialogTitle, { id: "form-dialog-title", className: "p-0 pb-10" },
            "Save ",
            data.type === 'publish' ? '& Publish' : ''),
        react_1.default.createElement(core_1.DialogContent, { className: "publish-content p-0 " },
            react_1.default.createElement("p", null,
                "Are you sure that you want ",
                data.text,
                " this")),
        react_1.default.createElement(core_1.DialogActions, { className: 'btn-group expert-modal-footer-button-group p-0' },
            react_1.default.createElement(core_1.Button, { color: "primary", className: 'v2-btn v2-btn-primary', onClick: () => save() }, "Save"),
            react_1.default.createElement(core_1.Button, { className: 'v2-btn v2-btn-tertiary', onClick: () => closeModal(), color: "secondary" }, "Never Mind")))));
};
const mapStateToProps = (state) => {
    const { modals } = state;
    return {
        open: modals.ADMIN.experts.save.open,
        data: modals.ADMIN.experts.save.data
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        triggerModal: (data) => dispatch(modalsSlice_1.triggerModal(data)),
        editExpert: (data) => dispatch(expertsSlice_1.editExpert(data)),
        submit: () => dispatch(expertsSlice_1.submit()),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ExpertSave);
